if (customElements.get('auto-carousel') === undefined) {
  class AutoCarousel extends HTMLElement {
    
    constructor() {
      super();
      this.animation = { duration: 8000, easing: (t) => t }
      this.total = this.getAttribute('total');
      this.spacing = this.getAttribute('spacing') || 16;
    }
  
    static get observedAttributes() {
    }
  
    connectedCallback() {
      this.cards = this.querySelectorAll('.keen-slider .slider__card');
      this.sliderElement = this.querySelector('.keen-slider');
      this.slides = this.sliderElement.childElementCount;
      if(this.slides > 0) this.initSlider();
    }
  
    disconnectedCallback() {
    }
  
    attributeChangedCallback(name, oldVal, newVal) {
    }
  
    adoptedCallback() {
    }

    build(slider) {
    }

    initSlider() {
     var animation = this.animation;
     var total = this.total;
     var spacing = this.spacing
      this.slider = new KeenSlider(this.sliderElement, {
        slides: {
          perView: "auto",
          spacing: spacing,
        },
        loop: true,
        renderMode: "performance",
        drag: false,
        created(s) {
          s.moveToIdx(5, true, animation)
        },
        updated(s) {
          s.moveToIdx(s.track.details.abs + 5, true, animation)
        },
        animationEnded(s) {
          s.moveToIdx(s.track.details.abs + 5, true, animation)
        },
        breakpoints: {
          '(min-width: 990px)': {
            slides: {
              perView: "auto",
              spacing: 24,
            },
          },
        }
      });
    }
  
  }
  customElements.define('auto-carousel', AutoCarousel);
}